import { Box, Chip } from '@mui/material';

import Icon from 'components/@icons/Icon';

interface Props {
  currentStep: number;
  totalSteps: number;
}

const Stepper = ({ currentStep, totalSteps }: Props) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      width="100%"
      mb={3}
    >
      {Array.from({ length: totalSteps }).map((_, index) => {
        const isActive = currentStep === index + 1;
        const isCompleted = currentStep > index + 1;

        return (
          <Box
            key={index}
            display="flex"
            alignItems="center"
            flex={index + 1 === totalSteps ? '0 0 auto' : 1}
          >
            <Chip
              label={
                isCompleted ? (
                  <Icon name="Check" height={16} width={16} color="grey.600" />
                ) : (
                  index + 1
                )
              }
              color={isActive ? 'secondary' : 'default'}
              variant={isActive ? 'filled' : 'outlined'}
              sx={{
                borderColor: isActive ? undefined : 'grey.600',
                paddingX: 1,
                width: 40,
              }}
            />
            {index + 1 < totalSteps && (
              <Box flex={1} height="1px" bgcolor="grey.600" />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default Stepper;
